/**
 * Generic API response shape - spojny format dla wszystkich Railway endpointow.
 *
 * Frontend (apps/web) i backend (apps/api) uzywaja TYCH SAMYCH typow zeby
 * brak driftu request/response. Caller robi `if (response.error)` i ma typesafe dostep.
 */

export interface ApiError {
  error: string;
  code: string;
  details?: Array<{ path: string; message: string }>;
}

export interface ApiSuccess<T> {
  data: T;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiError;

export function isApiError<T>(response: ApiResponse<T>): response is ApiError {
  return "error" in response;
}

// =====================================================
// AI Generation endpoint shapes
// =====================================================

export interface StartProcessingRequest {
  variantType: string;  // DB variant_type (np. "virtual_staging", "decluttering")
  sourceImage: string;  // data:image/...;base64,xxx
  parameters?: {
    style?: string;
    isRefresh?: boolean;
    previousJobId?: string;
    /** Życzenia użytkownika przy „Od nowa" (Home Staging / Pusty pokój). */
    customInstructions?: string;
  } & Record<string, unknown>;
}

/**
 * Synchroniczna odpowiedź generatorów (parytet v1): job kończy się w trakcie
 * requestu, resultImage wraca inline w 200. `purchased=false` gdy dedukcja padła
 * (obraz i tak wraca). Wspólny kształt: start-processing / room-arrangement /
 * team-photo / plot generate.
 */
export interface GeneratorResponse {
  jobId: string;
  resultImage: string;
  purchased: boolean;
  cost: number;
}

/** Floorplan step dodaje łańcuch (parentJobId) i numer kroku. */
export interface FloorPlanStepResponse extends GeneratorResponse {
  parentJobId: string;
  step: number;
  prompt?: string;
}

/** @deprecated polling wycofany — generatory zwracają wynik synchronicznie. Alias na GeneratorResponse. */
export type StartProcessingResponse = GeneratorResponse;

export interface JobStatusResponse {
  jobId: string;
  status: "pending" | "processing" | "done" | "failed";
  resultImage: string | null;
  errorMessage: string | null;
  purchased: boolean;
  /** Wariant z DB — ekran zdjęcia mapuje go na slug narzędzia. */
  variantType: string | null;
  /** Oferta, do której zdjęcie jest przypięte. `null` = nieprzypisane. */
  projectId: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}
